module.exports = __webpack_public_path__ + "h5/img/yisheng.8e808c7e.png";